import React from 'react';
import Loading from '../shared/Loading';

const Upload = ({ imageType, images, loading, handleChange, handleSubmit, token, ...props }) => (
  <div>
    <button
      type="button"
      className="edit-button"
      disabled={loading}
      onClick={() => {
        const input = document.getElementById(imageType);
        input.click();
      }}>
      {loading ? <span>UPLOADING..</span> : <span>+ UPLOAD</span>}
    </button>
    <input
      id={imageType}
      style={{ visibility: 'hidden' }}
      onChange={({ target: { files } }) => {
        const file = files[0];
        handleChange(imageType, file);
        handleSubmit({ variables: { file, imageType, token } });
      }}
      type="file"
      accept="image/jpg, image/jpeg, image/png, image/bmp, image/tif"
    />
    <div className="image-preview">
      {loading ? <Loading size="2x" /> : null}
      {images && props[imageType] ? <img src={images.uploadDocument.user[imageType]} alt="license" /> : null}
    </div>
  </div>
);

export default Upload;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/Upload.js